import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Learn", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "subtitle" }, "You can start learning the basics in this page", -1)
const _hoisted_5 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sections, (section, i) => {
        return (_openBlock(), _createBlock("div", {
          key: `section-${i}`,
          style: {"margin-top":"50px"}
        }, [
          _createVNode("div", _hoisted_5, _toDisplayString(section.name), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(section.links, (link) => {
            return (_openBlock(), _createBlock("div", {
              key: link,
              style: {"margin-top":"20px"}
            }, [
              _createVNode("iframe", {
                width: "100%",
                height: "500px",
                src: `https://www.youtube.com/embed/${link}`
              }, null, 8, ["src"])
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}